import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CUSTODIAN_ROLES, LENDER_ADMIN_ROLES, LENDER_ROLES } from '../constants/iam-roles.constants';
import { AuthService } from '../services/auth.service';

/**
 * internalOnlyGuard — blocks external lender/custodian users from internal setup pages.
 *
 * Run this AFTER authGuard so authentication and environment-role checks are
 * already confirmed.
 */
export const internalOnlyGuard: CanActivateFn = async (_route, _state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const isExternalUser = authService.hasRole(
    ...LENDER_ROLES,
    ...LENDER_ADMIN_ROLES,
    ...CUSTODIAN_ROLES
  );

  if (isExternalUser) {
    await router.navigate(['/access-denied']);
    return false;
  }

  return true;
};